const errors = {
    generic: 'An error occurred',
    notFound: 'Page not found',
    accessDenied: 'Access denied',
    accessDeniedReason: {
      admin: 'This page requires administrator privileges.',
      role: 'Your role does not allow access to this page.',
      permission: 'You do not have the permissions this page requires.',
    },
    accessDeniedContact: 'If you should have access, please contact your administrator.',
    pageNotFoundDescription: "The page you are looking for doesn't exist or has been moved.",
    unauthorized: 'Unauthorized',
    forbidden: 'Access denied',
    serverError: 'Server error occurred',
    networkError: 'Network error occurred',
    authenticationRequired: 'Authentication is required. Please log in again.',
    rateLimitExceeded: 'Too many requests. Please try again in a moment.',
  };

export default errors;
